import { HttpStatusCode } from '@angular/common/http';

export enum LoginErrorType {
  NO_CONNECTION = -1,
  UNKNOWN = 0,
  FORBIDDEN_APP_ACCESS = 1,
  SESSION_EXPIRED = HttpStatusCode.Unauthorized,
  FORBIDDEN_CONTENT = HttpStatusCode.Forbidden,
  NO_USER = HttpStatusCode.NotFound,
  REQUEST_TIMEOUT = HttpStatusCode.RequestTimeout,
  SERVER_ERROR = HttpStatusCode.InternalServerError,
  SERVICE_UNAVAILABLE = HttpStatusCode.ServiceUnavailable,
}

export enum ShouldLoginButtonType {
  Login = 'Login',
  Logout = 'Logout',
  Home = 'Home',
}

export interface LoginErrorInfo {
  title: string;
  description: string;
  buttonType?: ShouldLoginButtonType;
}

export const LoginMessages: Record<LoginErrorType, LoginErrorInfo> = {
  [LoginErrorType.NO_USER]: {
    title: 'User not created',
    description:
      'You are trying to login with a user that is not created. ' +
      'Please, contact your administrator.',
    buttonType: ShouldLoginButtonType.Logout,
  },
  [LoginErrorType.SESSION_EXPIRED]: {
    title: 'Session expired',
    description:
      'Your user is inactive, not created or your session has expired. Please, login again.\n' +
      'If the problem persists please contact your administrator.',
    buttonType: ShouldLoginButtonType.Logout,
  },
  [LoginErrorType.NO_CONNECTION]: {
    title: 'Could not connect to the server',
    description:
      'We could not connect to the server. Please contact your administrator. ',
    buttonType: ShouldLoginButtonType.Home,
  },
  [LoginErrorType.UNKNOWN]: {
    title: 'Unknown Error',
    description: 'This is an unknown error. Please contact your administrator.',
    buttonType: ShouldLoginButtonType.Login,
  },
  [LoginErrorType.FORBIDDEN_APP_ACCESS]: {
    title: 'Forbidden application access',
    description: `You don't have access to this app. Please contact your administrator.`,
    buttonType: ShouldLoginButtonType.Logout,
  },
  [LoginErrorType.FORBIDDEN_CONTENT]: {
    title: 'Content not available',
    description:
      'This content is not available. Please contact your administrator.',
    buttonType: ShouldLoginButtonType.Logout,
  },
  [LoginErrorType.REQUEST_TIMEOUT]: {
    title: 'Request took to long',
    description:
      'Looks like the server is taking to long to respond. Try again after a few minutes.\n' +
      'If the problem persists, please contact your administrator.',
    buttonType: ShouldLoginButtonType.Home,
  },
  [LoginErrorType.SERVER_ERROR]: {
    title: 'Oh no! Something went wrong',
    description:
      'Seems there is an error with the server. Please contact your administrator.',
    buttonType: ShouldLoginButtonType.Home,
  },
  [LoginErrorType.SERVICE_UNAVAILABLE]: {
    title: 'Service unavailable',
    description:
      'The service is temporarily unavailable. Please check back soon.\n' +
      'If the problem persists, contact your administrator.',
    buttonType: ShouldLoginButtonType.Home,
  },
};

export const LOGIN_ERROR_QUERY_PARAM_NAME = 'err';
